import { Route, Routes } from 'react-router-dom'
import MyLogsPage from './Page'

export default function MyLogs() {
  return (
    <Routes>
      <Route path="/*" element={<MyLogsPage />} />
      <Route path="/:id" element={<MyLogsPage />} />
    </Routes>
  )
}
